<template>
  <svg v-if="name" class="icon" :class="'icon-' + name" aria-hidden="true">
    <use :xlink:href="'#icon-' + name" />
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss"></style>
